import { FC, PropsWithChildren } from 'react'
import { PrismicLink } from '@prismicio/react'
import { LinkField } from '@prismicio/client'
import { TwStyle } from 'twin.macro'
import { distinctIdStore } from '../store/Store'
import { decorateURLWithUTMAndTIDParams } from '../utils'
import { trackEvent } from '../utils/trackEvent'

type Props = {
  field: LinkField
  trackEventParams: {
    pageTitle: string
    path: string
    target: string
    copy: string
  }
  id?: string
  cssStyle?: TwStyle | TwStyle[]
}

export const PrismicLinkOrDiv: FC<PropsWithChildren<Props>> = ({
  children,
  field,
  id,
  cssStyle,
}) => {
  if (!field) {
    return (
      <div id={id} css={cssStyle}>
        {children}
      </div>
    )
  }

  return (
    <PrismicLink id={id} field={field} css={cssStyle}>
      {children}
    </PrismicLink>
  )
}

const PrismicLinkInternalOrExternal: FC<PropsWithChildren<Props>> = ({
  children,
  trackEventParams,
  field,
  id,
  cssStyle,
}) => {
  const apiHost = process.env.GATSBY_API_HOST
  const { distinctId } = distinctIdStore

  const decoratedField =
    field.link_type.toLowerCase() === 'web'
      ? decorateURLWithUTMAndTIDParams(field, distinctId)
      : field

  return (
    <PrismicLink
      id={id}
      field={decoratedField}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        if (!apiHost) {
          return
        }
        trackEvent(apiHost, {
          distinctId,
          event: 'website_cta_clicked',
          host: location.host,
          path: location.pathname,
          urlParams: location.search,
          ...trackEventParams,
        })
      }}
      css={cssStyle}
    >
      {children}
    </PrismicLink>
  )
}

export default PrismicLinkInternalOrExternal
